import { render, staticRenderFns } from "./WaardenCard.vue?vue&type=template&id=fd2e944a&scoped=true&"
import script from "./WaardenCard.vue?vue&type=script&lang=js&"
export * from "./WaardenCard.vue?vue&type=script&lang=js&"
import style0 from "./WaardenCard.vue?vue&type=style&index=0&id=fd2e944a&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd2e944a",
  null
  
)

export default component.exports